// Sizes in words, and a progress line people can trust while a photo sends.

export function formatBytes(bytes: number): string {
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
	return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** "Sending your photo: 4.1 of 6.8 MB. Keep this page open." */
export function sendingText(what: string, sent: number, total: number): string {
	if (!total || !sent) return `Sending ${what}. Keep this page open.`;
	return `Sending ${what}: ${formatBytes(sent)} of ${formatBytes(total)}. Keep this page open.`;
}

/** A photo we can't take (not a photo, or too big): trying again won't help, so say what to do instead. */
export class PhotoRefused extends Error {}
